import request from '@/utils/request';
export const defaultDealersUserData = {
  id: 0,
  enabled: true,
  fullName: '',
  emailAddress: '',
  mobileNumber: '',
  walletBalance: 0,
  password: '',
  avatar: '',
  dealerId: undefined,
  dealer: {
    id: null
  }
};
export const defaultUserWalletData = {
  id: 0,
  enabled: true,
  amount: 0.0,
  action: 'credit',
  userId: null,
  orderId: null,
  user: {
    id: null
  },
  order: {
    id: null
  }
};
export const getDealersUsers = params => request({
  url: '/dealers-users',
  method: 'get',
  params
});
export const getDealersUserById = id => request({
  url: `/dealers-users/${id}`,
  method: 'get'
});
export const getUserByEmail = adminemail => request({
  url: `/dealers-users/${adminemail}`,
  method: 'get'
});
export const updateDealersUser = (id, data) => request({
  url: `/dealers-users/${id}`,
  method: 'patch',
  data
});
export const deleteDealersUser = adminname => request({
  url: `/dealers-users/${adminname}`,
  method: 'delete'
});
export const login = data => request({
  url: '/dealers-users/login',
  method: 'post',
  data
});
export const logout = () => request({
  url: '/dealers-users/logout',
  method: 'post'
});
export const register = data => request({
  url: '/dealers-users',
  method: 'post',
  data
});
export const dealersUserCount = params => request({
  url: '/dealers-users/count',
  method: 'get',
  params
});
export const getUsersWallets = params => request({
  url: '/wallet-transactions',
  method: 'get',
  params
});
export const addFundsToUserWaller = data => request({
  url: '/wallet-transactions',
  method: 'post',
  data
});